import { render, staticRenderFns } from "./Glitches.vue?vue&type=template&id=5b86cbe6&"
import script from "./Glitches.vue?vue&type=script&lang=js&"
export * from "./Glitches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports